import { makeStyles } from '@material-ui/core';
import accurisIcon from '../../assets/logos/icon.png';

const useStyles = makeStyles({
  img: {
    width: 44,
    height: 'auto',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return <img className={classes.img} src={accurisIcon} alt="Accuris" />;
};

export default LogoIcon;
